module.exports = __webpack_public_path__ + "static/img/tips_img1.ead78a61.png";